import "./hb-me.css";
import { html } from "lit-html";

export default html`
    <img id="hb-me-photo" class="w-7 h-7 rounded-full border-3 border-white" />
    <span id="hb-me-name" class="ml-2 text-base"></span>
`;
